export const fetchForm = (formId, { onlyPreview = false } = {}) => ({
  method: 'get',
  // host: 'https://enterprise-stage.api.trato.io/api',
  endpoint: `/forms/${formId}?onlyPreview=${onlyPreview}`,
  prefix: " ",
});

export const fetchUserForm = (formId, userFormId) => ({
  method: 'get',
  // host: 'https://enterprise-stage.api.trato.io/api',
  endpoint: `/forms/${formId}/user-forms/${userFormId}`,
  prefix: " ",
});

export const resendUserFormDocument = (formId, userFormId) => ({
  method: 'POST',
  // host: 'https://enterprise-stage.api.trato.io/api',
  endpoint: `/forms/${formId}/user-forms/${userFormId}/resend`,
  prefix: " ",
});

export const recoverUserForm = (body) => ({
  method: 'post',
  // host: 'https://enterprise-stage.api.trato.io/api',
  endpoint: `/forms/${body.formId}/user-forms/recover`,
  prefix: " ",
  body
});

export const answerForm = ({formId, ...values}) => ({
  method: 'post',
  // host: 'https://enterprise-stage.api.trato.io/api',
  endpoint: `/forms/${formId}`,
  prefix: " ",
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
});

export const saveUserForm = ({formId, userFormId, ...values}) => ({
  method: 'put',
  // host: 'https://enterprise-stage.api.trato.io/api',
  endpoint: `/forms/${formId}/user-forms/${userFormId}`,
  prefix: " ",
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
});